// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1924":"5bb493cb","1976":"8ff88249","8497":"2892a068","9003":"792136b0"}[chunkId] + ".chunk.css";
};